import React from "react";
import { createRoot } from "react-dom/client";
import LargeCarousel from "../components/LargeCarousel/LargeCarousel";

const renderLargeCarousel = ($) => {
	const carouselElements = $(".js-large-carousel");

	if (carouselElements) {
		Array.from(carouselElements).forEach((carousel) => {
			let props = {
				...(carousel && carousel.dataset),
			};
			const root = createRoot(carousel);
			root.render(<LargeCarousel {...props} />);
		});
	}
};

export default renderLargeCarousel;
